import { render } from "./cornerLogo.vue?vue&type=template&id=6478b714"
import script from "./cornerLogo.vue?vue&type=script&lang=js"
export * from "./cornerLogo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__